import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { RetrieveSelfData, TokensState } from "./types";

const initialState = {
	access: "",
	refresh: "",
	fcm_token: "",
	user_id: 0,
	partner_uuid: "",
	logged_user: undefined
} as TokensState;

export const tokensSlice = createSlice({
	name: "tokens",
	initialState,
	reducers: {
		setTokens: (state, action: PayloadAction<TokensState>) => {
			state.access = action.payload.access;
			state.refresh = action.payload.refresh;
		},
		setLogout: () => initialState,
		setAccessToken: (state, action: PayloadAction<string>) => {
			state.access = action.payload;
		},
		setRefreshToken: (state, action: PayloadAction<TokensState>) => {
			state.refresh = action.payload.refresh;
		},
		setFcm: (state, action: PayloadAction<string>) => {
			state.fcm_token = action.payload;
		},

		setPartnerUuid: (state, action: PayloadAction<string>) => {
			state.partner_uuid = action.payload;
		},

		setUserId: (state, action: PayloadAction<number>) => {
			state.user_id = action.payload;
		},

		setLoggedUser: (state, action: PayloadAction<RetrieveSelfData>) => {
			state.logged_user = action.payload;
		}
	}
});

export const {
	setTokens,
	setLogout,
	setAccessToken,
	setRefreshToken,
	setFcm,
	setPartnerUuid,
	setUserId,
	setLoggedUser
} = tokensSlice.actions;
export default tokensSlice.reducer;
